module.exports = __webpack_public_path__ + "img/slider_b02.d4210b7.b185514d.png";